<template>
  <section id="oferta" class="offer-section">
    <div class="container">
      <div class="section-header text-center mb-4">
        <h2 class="section-title">Cinco razones para decir que sí hoy</h2>
      </div>
      <div class="offer-list">
        <div v-for="(item, i) in reasons" :key="i">
          <h3>{{ item.title }}</h3>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * Oferta: 5 razones (mockup 2027).
 */
export default {
  name: 'OfferReasonsSection',
  data() {
    return {
      reasons: [
        {
          title: '$0 de inscripción',
          text: 'Antes $25. Para inscripciones hechas por agente hasta el 31 de marzo de 2027.'
        },
        {
          title: 'Cita en menos de 24 horas',
          text: 'Si no te damos cita en 24 horas hábiles, tu próximo mes es gratis.'
        },
        {
          title: 'Wellness desde el día 1',
          text: 'Paga 3 meses por adelantado y tus exámenes quedan 100% cubiertos de inmediato.'
        },
        {
          title: 'Paga 10, recibe 12',
          text: 'Dos meses gratis con el pago anual.'
        },
        {
          title: '30 días de garantía',
          text: 'Si no te convence y no usaste exámenes ni estudios, te devolvemos tu primer mes.'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.offer-section {
  padding: 80px 0;
  background: $landing-primary-color;
  color: #ffffff;
}

.section-title {
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  font-weight: 800;
  color: #ffffff !important;
  margin: 0;
}

.offer-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1px;
  background: #2c4a66;
  border: 1px solid #2c4a66;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 28px;
}

.offer-list div {
  background: $landing-primary-color;
  padding: 28px;
}

.offer-list h3 {
  color: #ffffff;
  margin: 0 0 8px;
  font-size: 1.15rem;
  font-weight: 700;
}

.offer-list p {
  color: #ffffff;
  font-size: 1rem;
  margin: 0;
  line-height: 1.45;
}

@media (max-width: 760px) {
  .offer-section {
    padding: 48px 0;
  }
}
</style>
